module.exports = __webpack_public_path__ + "static/media/logout.65a1eb61.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/logout.png
// module id = 697
// module chunks = 0